<template>
   <v-container class="py-12">
    <h2 >Pour afficher vos postulations veuillez sélectionner une année</h2>
    <v-select
      class="my-2"
      align="center"
      label="Année"
      v-model="selectedYear"
      :items="allYears"
      item-text="annee_academique"
      return-object
      hide-details
      :style="{ 'max-width': '100%', 'z-index': '3', 'margin': '20px' }"
    ></v-select>
    <ens-jobs-table
      v-show="ensApplications.length > 0"
      :jobs="ensApplications"
    ></ens-jobs-table>
    <adm-jobs-table
      v-show="admApplications.length > 0"
      :jobs="admApplications"
    ></adm-jobs-table>
    <v-alert
      v-show="ensApplications.length == 0 && admApplications.length == 0"
      type="warning"
      variant="tonal"
      text="Vous n'avez pas de postulations pour l'année sélectionnée"
      >
      Vous n'avez pas de postulations pour l'année sélectionnée
    </v-alert>
  </v-container>
</template>

<script>
import { mapState } from 'vuex';
import EnsJobsTable from '@/components/user-applications/EnsJobsTable.vue';
import AdmJobsTable from '@/components/user-applications/AdmJobsTable.vue';

const axios = require('axios').default;

export default {
  name: 'UserApplications',

  components: {
    'ens-jobs-table': EnsJobsTable,
    'adm-jobs-table': AdmJobsTable,
  },

  data: () => ({
    applications: [],
    candidate: Object,
    selectedYear: null,
    allYears: [],
  }),

  created() {
    this.getCandidate();

    this.getDates();
  },

  computed: {

    // ...mapState(['user']),

    ensApplications() {
       return this.testiplop.filter((application) => application.type_emploi === 'ENS' && application.annee_academique
      === this.selectedYear.annee_academique);
    },

    admApplications() {
      return this.testiplop.filter((application) => application.type_emploi === 'ADM' && application.annee_academique
      === this.selectedYear.annee_academique);
    },

    testiplop() {
      return this.applications.reduce((acc, current) => {
        const x = acc.find((item) => item.numero === current.numero);
        if (!x) {
          const item = { ...current };
          item.doublons = 1;
          return acc.concat([item]);
        }
        const index = acc.indexOf(x);
        acc[index].doublons += 1;
        return acc;
      }, []);
    },
  },

   methods: {
    async getCandidate() {
      try {
        const response = await axios.get(`candidats/${localStorage.getItem('user-id')}`);
        this.applications = [...response.data.postulations];
        console.log(this.ensApplications);
        console.log(this.admApplications);
        delete response.data.postulations;
        this.candidate = response.data;
        this.isLoadingCandidate = false;
      } catch (error) {
        this.$store.commit('SET_SNACKBAR', {
          isActive: true,
          text: 'Erreur lors de la récupération des postulations du candidat',
        });
      }
    },
    async getDates() {
      try {
        const dates = await axios.get('system_vacants');
        this.allYears = dates.data;
        console.log('all years');
        console.log(this.allYears);
        this.selectedYear = this.allYears[this.allYears.length - 1];
      } catch (error) {
        this.$store.commit('SET_SNACKBAR', {
          isActive: true,
          text: 'Erreur lors de la récupération des dates',
        });
      }
    },
  },
};

</script>
